import { type Enum } from '@webapp/infrastructure/types/Enum'

export const FinancialAccountStatuses = {
  ACTIVE: 'active',
  VERIFICATION_PENDING: 'verification_pending',
  CREATED: 'created',
  ONBOARDING: 'onboarding',
  INACTIVE: 'inactive',
  ACTION_REQUIRED: 'action_required',
  PLACEHOLDER: 'placeholder',
  ACTION_EVENTUALLY_REQUIRED: 'action_eventually_required',
  KYC_ONGOING_RFI_SUBMITTED: 'kyc_ongoing_rfi_submitted',
} as const

export type FinancialAccountStatusEnum = Enum<typeof FinancialAccountStatuses>

export const OPERATIONAL_FINANCIAL_ACCOUNT_STATUSES: FinancialAccountStatusEnum[] =
  [
    FinancialAccountStatuses.ACTIVE,
    FinancialAccountStatuses.ACTION_EVENTUALLY_REQUIRED,
    FinancialAccountStatuses.KYC_ONGOING_RFI_SUBMITTED,
  ]
